import React, { useEffect } from "react"
import * as styles from "./footer-bar-menu.module.scss"
import { FooterMenuFieldsFragment } from "../../../../../graphql-types"
import sanitizeHtml from "sanitize-html"
type RenderProps = {
  data: FooterMenuFieldsFragment
}
const FooterBarMenu: React.FC<RenderProps> = ({ data }) => {
  useEffect(() => {
    data.barMenu.forEach(x => {
      x.label = x.label.replace(
        " cookies",
        '&nbsp;<span lang="en">cookies</span>'
      )
    })
  }, [])
  return (
    <ul className={styles.collapsibleContentBottomMenu}>
      {data.barMenu.map(barMenuItem => (
        <li key={barMenuItem.label} className={styles.barMenuItem}>
          {barMenuItem.page ? (
            <a
              href={"/" + barMenuItem.page.slug}
              className={styles.barMenuLabel}
              dangerouslySetInnerHTML={{
                __html: sanitizeHtml(barMenuItem.label, {
                  allowedAttributes: {
                    span: ["lang"],
                  },
                }),
              }}
            ></a>
          ) : (
            <div key={barMenuItem.label} className={styles.barMenuLabel}>
              {barMenuItem.label}
            </div>
          )}
        </li>
      ))}
    </ul>
  )
}

export default FooterBarMenu
